import { put, call } from 'redux-saga/effects';
import { questionnaireEvaluationOverrideScoreSuccessAction, questionnaireEvaluationFailureAction } from '../actions';
import { QuestionnaireEvaluationQuestionService } from '../services';
export function* questionnaireEvaluationOverrideScoreSaga(action, questionnaireEvaluationQuestionsService = QuestionnaireEvaluationQuestionService.getInstance()) {
    try {
        yield call({
            context: questionnaireEvaluationQuestionsService,
            fn: questionnaireEvaluationQuestionsService.questionnaireEvaluationPostOverrideScore
        }, action.payload);
        yield put(questionnaireEvaluationOverrideScoreSuccessAction());
    }
    catch (error) {
        yield put(questionnaireEvaluationFailureAction(error.toString()));
    }
}
//# sourceMappingURL=questionnaireEvaluationOverrideScoreSaga.js.map